















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { windowHelper, util } from '@tencent/ppd-base-libs';
import Icon from '../icon/icon.vue';
import { i18nGet, install } from '../../i18n';
import { myBiReport } from '../../utils';
import { scanPay } from './scan';
import _dialog from '../common/dialog.vue';
import load from '../../utils/load';
import  { jumpScanpayByCVId, QrpayFromScene } from '@tencent/wphk-components-jump-page';

const dialog = load(_dialog);
const showDialog = dialog.show;

Vue.use(install);

@Component({
  components: {
    Icon,
  },
})
export default class PayComp extends Vue {
  @Prop() public theme!: string;
  @Prop() public userCvId!: string;
  @Prop({ default: {} }) public exBi!: any;
  /** 刷卡场景 */
  @Prop() public scene?: QrpayFromScene;

  public get payCodeType() {
    if (this.theme === 'white') return 'pay-code-green';
    return 'pay-code-white';
  }
  public get payScanType() {
    if (this.theme === 'white') return 'pay-scan-green';
    return 'pay-scan-white';
  }
  @Emit('clickPayCode')
  private async payCode() {
    myBiReport('paycomp_paycode_click', this.exBi);
    const { fcvtype } = this.exBi || {};
    const [err] = await util.to(jumpScanpayByCVId(this.userCvId, fcvtype || 'vouchers', { scene: this.scene }));
    if (err) {
      this.showErrorMsg(err);
    }
  }
  @Emit('clickScanCode')
  private async scanCode() {
    myBiReport('paycomp_scancode_click', this.exBi);
    const srcUrl = `${location.protocol}//${location.host}${location.pathname}${location.search}`;
    const [err, res] = await util.to(scanPay(srcUrl));
    if (err) {
      this.showErrorMsg(err);
    }
  }

  /**
   * 展示异常错误弹框
   */
  private showErrorMsg(err) {
    if (err) {
      const errMsg = err.retmsg
        || err.message
        || err.toString()
        || i18nGet('系統繁忙，請稍候再試。');
      showDialog({
        weui: true,
        content: errMsg,
        btns: [
          {
            text: i18nGet('知道了'),
          },
        ],
      });
    }
  }
}
